export default __webpack_public_path__ + "static/media/modernJs.4ea77a38.jpeg";